import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Title from './Title';
import { useSelector } from 'react-redux';
import {
  setParameters,
  removeParameter,
  clearParameters, setDateParameters
} from '../redux/global/actions';
import {
  getSystems,
  getSystemDetails,
  filterSystems,
  sortSystems,
  exportSystemsToCSV,
  getSystemsBulk,
} from '../redux/system/actions';
import {
  useNavigate,
} from "react-router-dom";
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import MultiValueInput from '../inputs/multiValueInput';
import DateInput from '../inputs/dateInput';
import { Accordion, AccordionDetails, AccordionSummary, Fab, Grid, IconButton, Menu, MenuItem, Modal, TextField, Tooltip, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useEffect } from 'react';
import './Systems.css';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import SearchDateInput from '../inputs/searchDateInput';
import MultiSelector from "../inputs/MultiSelector";
import {extractUserInfoFromToken, getLocalStorageSAMLToken} from "../utils";

export default function Systems(props) {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParameters = useSelector(state => state?.parameters?.systems);

  const [currentSystemId, setCurrentSystemId] = React.useState();
  const [currentBusinessPartner, setCurrentBusinessPartner] = React.useState();
  const [currentSoldTo, setCurrentSoldTo] = React.useState();
  const [currentOrder, setCurrentOrder] = React.useState();
  const [currentEndUser, setCurrentEndUser] = React.useState()
  const [currentSupportPartner, setCurrentSupportPartner] = React.useState();

  const [filterSystemIds, setFilterSystemIds] = React.useState([]);
  const [filterNames, setFilterNames] = React.useState([]);
  const [filterPartNumbers, setFilterPartNumbers] = React.useState([]);
  const [filterSoldTos, setFilterSoldTos] = React.useState([]);
  const [filterBusinessPartners, setFilterBusinessPartners] = React.useState([]);
  const [filterOrderIds, setFilterOrderIds] = React.useState([]);
  const [filterCreationDateStart, setFilterCreationDateStart] = React.useState();
  const [filterCreationDateEnd, setFilterCreationDateEnd] = React.useState();
  const [filterModificationDateStart, setFilterModificationDateStart] = React.useState();
  const [filterModificationDateEnd, setFilterModificationDateEnd] = React.useState();

  const handleExecuteSearch = () => {
      let queryObject = {
          limit: 100
      }
    if (queryParameters?.systemIds) {
      queryObject.system_id = queryParameters?.systemIds;
    };
    if (queryParameters?.names) {
      queryObject.name = queryParameters?.names;
    };
    if (queryParameters?.businessPartners) {
      queryObject.business_partner = queryParameters?.businessPartners;
    };
    if (queryParameters?.soldTos) {
      queryObject.sold_to = queryParameters?.soldTos;
    };
    if (queryParameters?.order) {
      queryObject.order = queryParameters?.order;
    };
    if (queryParameters?.endUser) {
      queryObject.end_user = queryParameters?.endUser;
    };
    if (queryParameters?.supportPartner) {
      queryObject.support_partner = queryParameters?.supportPartner;
    };
    if (queryParameters?.names) {
      queryObject.name = queryParameters?.names;
    };
    if (queryParameters?.creationDateStart && queryParameters?.creationDateEnd) {
      queryObject.creation_date_from = queryParameters?.creationDateStart;
      queryObject.creation_date_to = queryParameters?.creationDateEnd;
    };
    dispatch(getSystems(queryObject));
  };

  const handleExecuteBulkSearch = () => {
    let queryObject = {}
    if (queryParameters?.systemIds) {
      queryObject.system_id = queryParameters?.systemIds;
    };
    if (queryParameters?.names) {
      queryObject.name = queryParameters?.names;
    };
    if (queryParameters?.businessPartners) {
      queryObject.business_partner = queryParameters?.businessPartners;
    };
    if (queryParameters?.soldTos) {
      queryObject.sold_to = queryParameters?.soldTos;
    };
    if (queryParameters?.order) {
      queryObject.order = queryParameters?.order;
    };
    if (queryParameters?.endUser) {
      queryObject.end_user = queryParameters?.endUser;
    };
    if (queryParameters?.supportPartner) {
      queryObject.support_partner = queryParameters?.supportPartner;
    };
    if (queryParameters?.names) {
      queryObject.name = queryParameters?.names;
    };
    if (queryParameters?.creationDateStart && queryParameters?.creationDateEnd) {
      queryObject.creation_date_from = queryParameters?.creationDateStart;
      queryObject.creation_date_to = queryParameters?.creationDateEnd;
    };
    const saml_token = getLocalStorageSAMLToken();
    const infoToken = extractUserInfoFromToken(saml_token);
    queryObject.email = infoToken.email;
    queryObject.request_user = infoToken.username;
    dispatch(getSystemsBulk(queryObject));
  };

  const handleExecuteFilter = () => {
    let filterObject = {}
    if (filterSystemIds?.length > 0) {
      filterObject.systemIds = [filterSystemIds];
    };
    if (filterNames?.length > 0) {
      filterObject.names = [filterNames];
    }
    if (filterBusinessPartners?.length > 0) {
      filterObject.businessPartners = [filterBusinessPartners];
    };
    if (filterSoldTos?.length > 0) {
      filterObject.soldTos = [filterSoldTos];
    };
    if (filterPartNumbers?.length > 0) {
      filterObject.partNumbers = [filterPartNumbers];
    };
    if (filterOrderIds?.length > 0) {
      filterObject.orderIds = [filterOrderIds];
    };
    if (filterCreationDateStart) {
      filterObject.filterCreationDateStart = filterCreationDateStart;
    };
    if (filterCreationDateEnd) {
      filterObject.filterCreationDateEnd = filterCreationDateEnd;
    };
    dispatch(filterSystems(filterObject));
  };

  const nameValues = [
    "OXE",
    "OXO",
  ];

  useEffect(() => {
    handleExecuteFilter()
  }, [
    filterSystemIds,
    filterNames,
    filterPartNumbers,
    filterSoldTos,
    filterBusinessPartners,
    filterOrderIds,
    filterCreationDateStart,
    filterCreationDateEnd,
    filterModificationDateStart,
    filterModificationDateEnd
  ]);

  function handleSelectSystem(systemId) {
    dispatch(getSystemDetails(systemId));
    navigate('/systems/details/' + systemId);
  };

  const handleDeleteSystemId = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { systemIds: [chipToDelete] } }));
  };

  const handleClearSystemIds = () => {
    dispatch(clearParameters({ systems: 'systemIds' }));
  };

  const handleDeleteNames = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { names: [chipToDelete] } }));
  };

  const handleClearNames = () => {
    dispatch(clearParameters({ systems: 'names' }));
  };

  const handleDeleteBusinessPartner = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { businessPartners: [chipToDelete] } }));
  };

  const handleClearBusinessPartners = () => {
    dispatch(clearParameters({ systems: 'businessPartners' }));
  };

  const handleDeleteSoldTo = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { soldTos: [chipToDelete] } }));
  };

  const handleClearSoldTo = () => {
    dispatch(clearParameters({ systems: 'soldTos' }));
  };

  const handleDeleteOrder = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { order: [chipToDelete] } }));
  };

  const handleClearOrder = () => {
    dispatch(clearParameters({ systems: 'order' }));
  };

  const handleDeleteEndUser = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { endUser: [chipToDelete] } }));
  };

  const handleClearEndUser = () => {
    dispatch(clearParameters({ systems: 'endUser' }));
  };

  const handleDeleteSupportPartner = (chipToDelete) => () => {
    dispatch(removeParameter({ systems: { supportPartner: [chipToDelete] } }));
  };

  const handleClearSupportPartner = () => {
    dispatch(clearParameters({ systems: 'supportPartner' }));
  };

  const handleExportToCSV = (systems) => {
    dispatch(exportSystemsToCSV(systems))
  };

  const systems = useSelector(state => {
    if (state.filteredSystems) {
      return state.filteredSystems.map((system) => {
        return {
          system_id: system?.system_id,
          support_partner: system?.support_partner?.company_id,
          status: system?.status,
          sold_to: system?.sold_to?.applicant_id,
          release: system?.release,
          product: system?.product,
          part_number: system?.part_number,
          order: system?.order,
          name: system?.name,
          modification_date: system?.modification_date,
          inactive_reason: system?.inactive_reason,
          description: system?.description,
          creation_note: system?.creation_note,
          creation_date: system?.creation_date,
          cpu_id1: system?.cpu_id1,
          cpu_id2: system?.cpu_id2,
          comments: system?.comments,
          business_partner: system?.business_partner?.company_id,
          children: system?.children
        }
      })
    }
    else return []
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(document.getElementById("menuAnchor"));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterDescription = 'Add filters to the list of results, and export the filtered list to CSV';

  const [sortDirection, setSortDirection] = React.useState('');
  const [sortParameter, setSortParameter] = React.useState('');

  const handleSortSystems = (sortParameter) => {
    setSortParameter(sortParameter);
    if (sortDirection === '') {
      setSortDirection('ascending');
      dispatch(sortSystems(sortParameter, 'ascending'));
    } else if (sortDirection === 'ascending') {
      setSortDirection('descending');
      dispatch(sortSystems(sortParameter, 'descending'));
    } else {
      setSortDirection('ascending');
      dispatch(sortSystems(sortParameter, 'ascending'));
    };
  };

  const [expanded, setExpanded] = React.useState(null);
  const [openBulkConfirmation, setOpenBulkConfirmation] = React.useState(false);
  const [openBulkMessage, setOpenBulkMessage] = React.useState(false);

  const handleKeydown = (event) => {
    if (event.key == 'Enter') {
      event.stopPropagation();
      event.preventDefault();
      setTimeout(() => {
        handleExecuteSearch();
      }, 0);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  return (
    <React.Fragment>
      <Modal
       open={openBulkMessage}
       style={{
         textAlign: "center",
         paddingTop: "45vh"
       }}>
        <>
          <Typography
           style={{ color: 'white' }}
          >
            Your query has been sent. You can follow the status in the Bulk Report page or wait for the Rainbow message that will announce the end of the export.
          </Typography>
          <div style={{ paddingBottom: '1%' }} />
          <Grid container className='headercontainer'>
            <Grid item>
              <Button
               style={{
                 color: 'white',
                 background: '#6b469e'
               }}
               onClick={() => { setOpenBulkMessage(false); }}
              >Ok</Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <Modal
       open={openBulkConfirmation}
       style={{
         textAlign: "center",
         paddingTop: "45vh"
       }}>
        <>
          <Typography
           style={{ color: 'white' }}
          >
            This query could take a few minutes, are you sure you want to continue?
          </Typography>
          <div style={{ paddingBottom: '1%' }} />
          <Grid container className='headercontainer'>
            <Grid item>
              <Button
               style={{
                 color: 'white',
                 background: '#6b469e'
               }}
               onClick={() => { handleExecuteBulkSearch(); setOpenBulkConfirmation(false); setOpenBulkMessage(true) }}
              >Yes</Button>
            </Grid>
            <Grid item style={{ width: '7%' }} />
            <Grid item>
              <Button
               style={{
                 color: 'white',
                 background: '#6b469e'
               }}
               onClick={() => setOpenBulkConfirmation(false)}
              >No</Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <div style={{ paddingBottom: '1%' }} />
      <Grid container className='headercontainer'>
      </Grid>
      <MultiValueInput
        setCurrentParam={setCurrentSystemId}
        setQueryParams={setParameters}
        currentParam={currentSystemId}
        queryParams={queryParameters?.systemIds}
        handleDelete={handleDeleteSystemId}
        handleClear={handleClearSystemIds}
        label="System ID"
        family='systems'
        type='systemIds'
      />
      <MultiValueInput
        setCurrentParam={setCurrentBusinessPartner}
        setQueryParams={setParameters}
        currentParam={currentBusinessPartner}
        queryParams={queryParameters?.businessPartners}
        handleDelete={handleDeleteBusinessPartner}
        handleClear={handleClearBusinessPartners}
        label="Business Partner"
        family='systems'
        type='businessPartners'
      />
      <MultiValueInput
        setCurrentParam={setCurrentSoldTo}
        setQueryParams={setParameters}
        currentParam={currentSoldTo}
        queryParams={queryParameters?.soldTos}
        handleDelete={handleDeleteSoldTo}
        handleClear={handleClearSoldTo}
        label="Sold To"
        family='systems'
        type='soldTos'
      />
      <MultiValueInput
        setCurrentParam={setCurrentOrder}
        setQueryParams={setParameters}
        currentParam={currentOrder}
        queryParams={queryParameters?.order}
        handleDelete={handleDeleteOrder}
        handleClear={handleClearOrder}
        label="SAP Order"
        family='systems'
        type='order'
      />
      <MultiValueInput
        setCurrentParam={setCurrentEndUser}
        setQueryParams={setParameters}
        currentParam={currentEndUser}
        queryParams={queryParameters?.endUser}
        handleDelete={handleDeleteEndUser}
        handleClear={handleClearEndUser}
        label="End Customer ID"
        family='systems'
        type='endUser'
      />
      <MultiValueInput
        setCurrentParam={setCurrentSupportPartner}
        setQueryParams={setParameters}
        currentParam={currentSupportPartner}
        queryParams={queryParameters?.supportPartner}
        handleDelete={handleDeleteSupportPartner}
        handleClear={handleClearSupportPartner}
        label="Support Partner"
        family='systems'
        type='supportPartner'
      />
      <MultiSelector
        setQueryParams={setParameters}
        queryParams={queryParameters?.names}
        handleDelete={handleDeleteNames}
        handleClear={handleClearNames}
        label="Name"
        family='systems'
        type='names'
        options={nameValues}
      />
      <Grid>
        <SearchDateInput
          title={'Creation Date'}
          setFilterDate={setDateParameters}
          family='systems'
          type='creationDateStart'
          type2='creationDateEnd'
        />
      </Grid>
      <Grid
        container
        style={{
          justifyContent: 'center'
        }}
      >
        <Grid item>
          <Button variant="contained" onClick={handleExecuteSearch} style={{ width: '15vw' }}>Search</Button>
        </Grid>
        <div style={{ paddingLeft: '0.2%' }} />
        <Grid item>
          <Button variant="contained" onClick={() => setOpenBulkConfirmation(true)} style={{ width: '15vw' }}>Bulk Export</Button>
        </Grid>
      </Grid>
      <Title>Systems</Title>
      <Typography>
        {systems?.length ?
          systems?.length === 100 ?
          systems?.length + ' results, use bulk export for more' :
          systems?.length + ' results' :
          null
        }
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  <TextField
                    label="System ID"
                    variant='standard'
                    onChange={(e) => { setFilterSystemIds(e.target.value) }}
                    onKeyDown={(e) => { e.stopPropagation(); }}
                  />
                </Grid>
                <Grid item
                  onClick={() => handleSortSystems('system_id')}
                  style={{ alignSelf: 'center' }}
                >
                  {sortDirection === 'ascending' && sortParameter === 'system_id' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'system_id' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  Creation Date
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortSystems('creation_date')}
                >
                  {sortDirection === 'ascending' && sortParameter === 'creation_date' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'creation_date' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  Modification Date
                </Grid>
                <Grid
                  item
                  onClick={() => handleSortSystems('modification_date')}
                >
                  {sortDirection === 'ascending' && sortParameter === 'modification_date' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'modification_date' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  <TextField
                    label="Name"
                    variant='standard'
                    onChange={(e) => { setFilterNames(e.target.value) }}
                    onKeyDown={(e) => { e.stopPropagation(); }}
                  />
                </Grid>
                <Grid item
                  onClick={() => handleSortSystems('name')}
                  style={{ alignSelf: 'center' }}
                >
                  {sortDirection === 'ascending' && sortParameter === 'name' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'name' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  <TextField
                    label="Sold To"
                    variant='standard'
                    onChange={(e) => { setFilterSoldTos(e.target.value) }}
                    onKeyDown={(e) => { e.stopPropagation(); }}
                  />
                </Grid>
                <Grid item
                  onClick={() => handleSortSystems('sold_to.applicant_id')}
                  style={{ alignSelf: 'center' }}
                >
                  {sortDirection === 'ascending' && sortParameter === 'sold_to.applicant_id' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'sold_to.applicant_id' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  <TextField
                    label="Business Partner"
                    variant='standard'
                    onChange={(e) => { setFilterBusinessPartners(e.target.value) }}
                    onKeyDown={(e) => { e.stopPropagation(); }}
                  />
                </Grid>
                <Grid item
                  onClick={() => handleSortSystems('business_partner.company_id')}
                  style={{ alignSelf: 'center' }}
                >
                  {sortDirection === 'ascending' && sortParameter === 'business_partner.company_id' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'business_partner.company_id' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container className='headercontainer'>
                <Grid item>
                  <TextField
                    label="Order ID"
                    variant='standard'
                    onChange={(e) => { setFilterOrderIds(e.target.value) }}
                    onKeyDown={(e) => { e.stopPropagation(); }}
                  />
                </Grid>
                <Grid item
                  onClick={() => handleSortSystems('order.order_id')}
                  style={{ alignSelf: 'center' }}
                >
                  {sortDirection === 'ascending' && sortParameter === 'order.order_id' ? <KeyboardArrowDownIcon className='sortbutton' /> :
                    sortDirection === 'descending' && sortParameter === 'order.order_id' ? <KeyboardArrowUpIcon className='sortbutton' /> :
                      <UnfoldMoreIcon className='sortbutton' />
                  }
                </Grid>
              </Grid>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {systems.map((row, i) => (
            <React.Fragment
              key={row?.serial_number + i}
            >
              <TableRow
                hover
                onClick={() => { handleSelectSystem(row?.system_id) }}
                style={{
                  cursor: 'pointer'
                }}>
                <TableCell>
                  <Tooltip title={row?.children ? 'Show/hide children' : ''} placement="top">
                    <span>
                      <IconButton
                        style={{
                          // display: row?.children ? 'block' : 'none',
                          opacity: row?.children ? 1 : 0
                        }}
                        disabled={row?.children ? false : true}
                        onClick={(e) => {
                          if (expanded === row?.serial_number) {
                            setExpanded()
                          } else {
                            setExpanded(row?.serial_number)
                          }
                          e.stopPropagation()
                        }}
                      >
                        {expanded === row?.serial_number && <KeyboardArrowDownIcon />}
                        {expanded !== row?.serial_number && <KeyboardArrowRightIcon />}
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title={row?.parent ? 'Show/hide parent' : ''} placement="top">
                    <span>
                      <IconButton
                        style={{
                          // display: row?.children ? 'block' : 'none',
                          opacity: row?.parent ? 1 : 0
                        }}
                        disabled={row?.parent ? false : true}
                        onClick={(e) => {
                          if (expanded === row?.serial_number) {
                            setExpanded()
                          } else {
                            setExpanded(row?.serial_number)
                          }
                          e.stopPropagation()
                        }}
                      >
                        {expanded === row?.serial_number && <KeyboardArrowDownIcon />}
                        {expanded !== row?.serial_number && <KeyboardArrowRightIcon />}
                      </IconButton>
                    </span>
                  </Tooltip>
                  {row?.system_id}
                </TableCell>
                <TableCell>{row?.creation_date}</TableCell>
                <TableCell>{row?.modification_date}</TableCell>
                <TableCell>{row?.name}</TableCell>
                <TableCell>{row?.sold_to}</TableCell>
                <TableCell>{row?.business_partner}</TableCell>
                <TableCell>{row?.order?.order_id}</TableCell>
              </TableRow>
              <Accordion
                expanded={expanded === row?.serial_number && row?.children}
              >
                <AccordionSummary style={{ display: 'none' }} />
                <AccordionDetails>
                  {/* <MaterialChildren material={row} /> */}
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === row?.serial_number && row?.parent}
              >
                <AccordionSummary style={{ display: 'none' }} />
                <AccordionDetails>
                  {/* <MaterialParents material={row} /> */}
                </AccordionDetails>
              </Accordion>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>

      <Tooltip
        title={<Typography fontSize={17}>{filterDescription}</Typography>}
      >
        <Fab
          style={{
            position: 'absolute',
            right: 10,
            bottom: 10,
            backgroundColor: "#6b469e",
            color: "white",
            height: "5em",
            width: "5em"
          }}
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <div
            id="menuAnchor"
            style={{
              position: 'relative',
              bottom: 500,
              right: 250
            }}
          >
          </div>
          <FileDownloadIcon fontSize="large" style={{ height: "70%", width: "70%" }} />
        </Fab>
      </Tooltip>
      <div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem >
            <TextField
              label="Serial Number"
              onChange={(e) => { setFilterSystemIds(e.target.value) }}
              onKeyDown={(e) => { e.stopPropagation(); }}
            />
          </MenuItem>
          <MenuItem >
            <Grid>
              <div>
                Creation Date
              </div>
              <DateInput
                setFilterDateStart={setFilterCreationDateStart}
                setFilterDateEnd={setFilterCreationDateEnd}
              />
            </Grid>
          </MenuItem>
          <MenuItem >
            <Grid>
              <div>
                Modification Date
              </div>
              <DateInput
                setFilterDateStart={setFilterModificationDateStart}
                setFilterDateEnd={setFilterModificationDateEnd}
              />
            </Grid>
          </MenuItem>
          <MenuItem >
            <TextField
              label="Part Number"
              onChange={(e) => { setFilterPartNumbers(e.target.value) }}
              onKeyDown={(e) => { e.stopPropagation(); }}
            />
          </MenuItem>
          <MenuItem >
            <TextField
              label="Sold To"
              onChange={(e) => { setFilterSoldTos(e.target.value) }}
              onKeyDown={(e) => { e.stopPropagation(); }}
            />
          </MenuItem>
          <MenuItem >
            <TextField
              label="Business Partner"
              onChange={(e) => { setFilterBusinessPartners(e.target.value) }}
              onKeyDown={(e) => { e.stopPropagation(); }}
            />
          </MenuItem>
          <MenuItem >
            <Button variant="contained" onClick={() => {
              handleExportToCSV(systems)
            }}>Export systems</Button>
          </MenuItem>
        </Menu>
      </div>
    </React.Fragment >
  );
}
